import React from 'react';

const Footer = () => (
    <footer className="footer">
        <p>
            <small>
                "You know what's weird? Day by day, nothing seems to change,<br />
                but pretty soon... everything's different." - Calvin &amp;
                Hobbes
            </small>
        </p>
        <div>
            Made with <strong> &#x2764;</strong> by{' '}
            <a
                href="https://codeadrian.github.io"
                target="_blank"
                rel="noopener noreferrer"
            >
                Adrian Bece
            </a>{' '}
            for{' '}
            <a
                href="https://www.inchoo.net"
                target="_blank"
                rel="noopener noreferrer"
            >
                Inchoo
            </a>
        </div>
    </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx